"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enum = void 0;
const typescript_1 = require("typescript");
const typed_class_element_1 = require("./types/typed-class-element");
class Enum extends typed_class_element_1.TypedClassElement {
    constructor() {
        super(...arguments);
        this.enumValues = {};
    }
    parse(node) {
        super.parse(node);
        node.members.forEach(m => {
            var _a, _b, _c;
            let text = (_a = m.initializer) === null || _a === void 0 ? void 0 : _a.text;
            let value = ((_b = m.initializer) === null || _b === void 0 ? void 0 : _b.kind) == typescript_1.SyntaxKind.NumericLiteral ? Number.parseInt(text) : text;
            let enumKey = (_c = m.name) === null || _c === void 0 ? void 0 : _c.escapedText;
            this.enumValues[enumKey] = value;
        });
    }
    get value() {
        return Object.keys(this.enumValues).map(k => {
            let val = this.enumValues[k];
            let type = typeof val === "string" ? "string" : "number";
            return {
                name: k,
                kind: "enum",
                type: type,
                knownType: type,
                value: val
            };
        });
    }
}
exports.Enum = Enum;
